import { mapGetters } from 'vuex'
import { Constants } from 'src/constants'
import recaptchaService from 'src/recaptcha'


export const SCOPES_FAVICON_URL = {
  [Constants.colorTheme.AUDT]: '/img/favicon/audt.ico',
  [Constants.colorTheme.TIMEX]: '/img/favicon/timex.ico'
}

export const DEFAULT_FAVICON_URL = '/img/favicon/chronobank.ico'

export default {
  name: 'app',
  computed: {
    ...mapGetters({
      context: 'passport/context',
      config: 'config/config',
    }),
    colorTheme () {
      if (this.context) {
        return this.context.client.options.colorTheme
      }
      return 'default'
    },
  },
  metaInfo () {
    const script = []

    if (recaptchaService.enabled) {
      script.push({
        src: recaptchaService.getScriptSrc()
      })
    }

    return {
      script
    }
  },
  watch: {
    context: {
      handler () {
        // change favicon
        const { context, $vuetify } = this
        if (context && context.client.options.colorTheme) {
          const colorTheme = context.client.options.colorTheme
          $vuetify.theme.dark = false
          $vuetify.theme.light = colorTheme === Constants.colorTheme.AUDT
          document.querySelector("link[rel*='icon']").href = SCOPES_FAVICON_URL[colorTheme]
        } else {
          $vuetify.theme.dark = true
          $vuetify.theme.light = false
          document.querySelector("link[rel*='icon']").href = DEFAULT_FAVICON_URL
        }
      },
      immediate: true
    }
  }
}
